export default "__VITE_ASSET__CwFanKad__"